<template>
  <div class='h-dialogContainer h-alarm-filter'>
    <form id="addGnbReportTemplateDialog">
      <div class='row h-row-around-inputBox'>
        <div class='col-sm-6'>
          <div class='h-col-inputBox'>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.templateName')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <input class="e-control e-textbox e-lib e-input" :readonly="true" name="templateName" type="text" v-model="templateName">
            </div>
          </div>
          <div class='h-col-inputBox'>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.resourceType')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <input class="e-control e-textbox e-lib e-input" :readonly="true" name="neTypeName" type="text" v-model="neTypeName">
            </div>
          </div>
          <div class='h-col-inputBox'>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.paramType')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <input class="e-control e-textbox e-lib e-input" :readonly="true" name="neTypeName" type="text" v-model="paramTypeName">
            </div>
          </div>
          <div class='h-col-inputBox'>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('Pm.counterSpace')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <input class="e-control e-textbox e-lib e-input" :readonly="true" name="neTypeName" type="text" v-model="spaceName">
            </div>
          </div>
        </div>
        <div class='col-sm-6'>
          <div class="h-col-inputBox-right">
            <div class="h-inputLit">{{$t('Pm.chooseCounters')}}</div>
            <ejs-treeview
              ref='gnbPmReportTemplateEditTree'
              :expandedNodes='expandedEditNodes'
              :fields='fieldsOfGnbPmReportTemplateEditTree'
              :showCheckBox='true'
              :nodeChecked="gnbPmDataEditTreeNodeChecked">
            </ejs-treeview>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

  export default {
    name: 'EditGnbReportTemplate',
    components: {
    },
    data() {
      return {
        templateId: '',
        templateName: '',
        neTypeCode: '',
        neTypeName: '',
        paramTypeCode: '',
        paramTypeName: '',
        spaceCode: '',
        spaceName: '',
        expandedEditNodes: ['root'],
        customCounterList:{},
        systemCounterList:{},
        fieldsOfGnbPmReportTemplateEditTree: {
          dataSource: [],
          id: 'id',
          parentID: 'parentId',
          text: 'name',
          hasChildren: 'hasChildren',
          expanded: 'expanded'
        }
      }
    },
    methods: {
      gnbPmDataEditTreeNodeChecked(args){
        const checkStatus = args.action;
        if(checkStatus == "check"){
          for(let checkedNode of args.data){
            if(checkedNode.hasChildren == false){
              if(checkedNode.parentID == "system"){
                this.systemCounterList[checkedNode.id] = checkedNode.text;
              }else{
                this.customCounterList[checkedNode.id] = checkedNode.text;
              }
            }
          }
        }else if(checkStatus == 'uncheck'){
          for(let checkedNode of args.data){
            if(checkedNode.parentID == "system" && this.systemCounterList[checkedNode.id] != null && this.systemCounterList[checkedNode.id] != undefined ){
              delete this.systemCounterList[checkedNode.id];
            }else if(checkedNode.parentID == "custom" && this.customCounterList[checkedNode.id] != null && this.customCounterList[checkedNode.id] != undefined){
              delete this.customCounterList[checkedNode.id];
            }
          }
        }
      },

      getCounterList(checkedNodes){
        this.$axios.get(`/lte/ems/pm/gnb/report/template/getCounterList.html?paramTypeCode=${this.paramTypeCode}&spaceCode=${this.spaceCode}`).then((response) => {
          this.fieldsOfGnbPmReportTemplateEditTree = {
            dataSource: response.data.resultVal,
            id: 'id',
            parentID: 'parentId',
            text: 'name',
            hasChildren: 'hasChildren',
            expanded: 'expanded'
          };
          this.$refs.gnbPmReportTemplateEditTree.ej2Instances.checkedNodes = checkedNodes;
        });
      },
    },
    mounted() {
    }
  }
</script>

<style scoped>
</style>
